import gql from "graphql-tag"
import { GroupFragmentDoc, ResourceFragmentDoc } from "../../api/generated"

export default gql`
  query GroupQueryResourcePath($id: Int!) {
    group(id: $id) {
      ...Group
      resource {
        ...Resource
      }
      path(type: source) {
        # NOTE: note including Path fragment as there is an inefficent query for joining in the sync data
        id
        points {
          path_id
          has_points
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`
